import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface CampaignFolder {
  id: number;
  name: string;
  campaignCount: number;
  createdAt: string;
}

@Injectable({ providedIn: 'root' })
export class MarketingFolderApiService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}api/marketing/folders`;

  list(): Observable<CampaignFolder[]> {
    return this.http.get<CampaignFolder[]>(this.base);
  }

  create(name: string): Observable<CampaignFolder> {
    return this.http.post<CampaignFolder>(this.base, { name });
  }

  rename(id: number, name: string): Observable<CampaignFolder> {
    return this.http.put<CampaignFolder>(`${this.base}/${id}`, { name });
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`);
  }
}
